module.exports = __webpack_public_path__ + "img/Balance-2-mobile.4e47e9bd.jpg";